export const getSelectPopupContainer = () =>
  document.getElementById('room-form');
